import clsx from 'clsx';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { Typography } from '@/shared/components/atoms';
import { ISideMenu } from '@/shared/components/molecules/SideMenu/types';
import { UpgradePlanModal } from '@/shared/components/molecules/Subscription/UpgradePlan';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import Lock from '~/images/shared/Lock.svg';

const SideMenuLink: React.FC<ISideMenu.ISideMenuItemProps> = ({
  item,
  openCollapse,
}) => {
  const router = useRouter();

  const { openModal } = useModal();

  const linkStyle = () =>
    clsx(
      'flex items-center justify-between cursor-pointer gap-2 rounded-lg aria-[current=false]:hover:bg-outline-default aria-[current=false]:text-text-default aria-[current=page]:bg-outline-default aria-[current=page]:text-primary-400 ',
      openCollapse ? 'p-2' : 'p-1',
      item.className
    );

  return item.clickable ? (
    <Link
      prefetch={false}
      legacyBehavior
      href={item.nestedMenu ? '' : item.route}
    >
      <div
        onClick={(e) => item.clickHandler?.(e)}
        className={clsx(!openCollapse && 'flex items-center justify-center')}
      >
        <a
          title={openCollapse ? '' : item.title}
          aria-current={
            router.pathname === item.route ||
            (router.pathname.includes(item.route) &&
              router.pathname !== '/' &&
              item.route !== '/')
              ? 'page'
              : false
          }
          className={linkStyle()}
        >
          <div className='flex items-center gap-2'>
            <div className='text-primary-400'>{item.icon}</div>
            <Typography
              variant='subtitle2'
              className={clsx('duration-200', !openCollapse && 'hidden')}
            >
              {item.title}
            </Typography>
          </div>
        </a>
      </div>
    </Link>
  ) : (
    <div
      className={clsx(!openCollapse && 'flex items-center justify-center')}
      onClick={() => openModal(<UpgradePlanModal variant={item.title} />)}
    >
      <span className={linkStyle()}>
        <div className='flex items-center gap-2'>
          <div>{item.icon}</div>
          <Typography
            variant='subtitle2'
            className={clsx('duration-200', !openCollapse && 'hidden')}
          >
            {item.title}
          </Typography>
        </div>
        {openCollapse && (
          <div>
            <Lock />
          </div>
        )}
      </span>
    </div>
  );
};
export default SideMenuLink;
